import { ERequestType } from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {BLOCK_REASONS_LIST_URL} from '../model/constants';
import {IFetchUserStatusArgs} from '../model/types';

export const fetchUserStatus = ({url, data}: IFetchUserStatusArgs) =>
    performRequest({url, method: ERequestType.POST, data});

export const fetchBlockReasons = () => performRequest({url: BLOCK_REASONS_LIST_URL, method: ERequestType.GET});
